export default () => ({
  items: [],
  meta: {},
  loading: false,
  creating: false,
  // Список пользователей филиала для селекта исполнителя (лениво, in-memory до логаута).
  users: [],
  usersLoaded: false,
});
